import {getWordBreakClassName} from 'lib/stringHelper';
import PropTypes from 'prop-types';

function TaskDescriptionSerialDilution({labwareName, wellGroup}) {
  return (
    <>
      &nbsp;
      <span>from the</span>
      &nbsp;
      <span className={`${getWordBreakClassName(labwareName, 19)}`}>
        {`${labwareName} `}
        <span className="green">{`[${wellGroup}]`}</span>
      </span>
    </>
  );
}

TaskDescriptionSerialDilution.propTypes = {
  labwareName: PropTypes.string.isRequired,
  wellGroup: PropTypes.string.isRequired,
};

export default TaskDescriptionSerialDilution;
